import {Box, Tooltip} from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import NumberFormat from "react-number-format";
import React, {useEffect, useState} from "react";
import {useNavStyles} from "./Navbar";
import {getRopInfo} from "../../pages/huntersKpi/api";
import cookiesService from "../../services/cookiesService";

const cookiesServiceInstance = cookiesService.getService();

// TZ раздел 5.5 — РОП видит свои бонусы (rop_info) в навбаре, аналогично SellerSide хантера.
export const RopSide = () => {
  const classes = useNavStyles();
  const [ropInfo, setRopInfo] = useState({});

  const {position_code} = cookiesServiceInstance.getUserData();

  useEffect(() => {
    if (position_code === "SALE_HEAD")
      getRopInfo().then(res => {
        setRopInfo(res || {});
      });
  }, [position_code]);

  if (position_code !== "SALE_HEAD" || !ropInfo?.rop_id) return null;

  return <Box className={classes.kpi_info}>
    <Box className={classes.kpi_info_plan}>
      <p>План ОП:</p>
      <span>
        <NumberFormat
          value={ropInfo?.dept_plan}
          thousandSeparator={" "}
          displayType="text"
        />
      </span>
    </Box>
    <Box className={classes.kpi_info_percent}>
      <p>Процент:</p>
      <span>
        <NumberFormat
          value={ropInfo?.dept_pct}
          thousandSeparator={" "}
          displayType="text"
        />
        {ropInfo?.is_streak_star ? (
          <Tooltip title={`Стабильность: план выполнен ${ropInfo?.streak} мес. подряд`}>
            <StarIcon fontSize="small" style={{color: "#FFC107", verticalAlign: "middle", marginLeft: 4}}/>
          </Tooltip>
        ) : null}
        {ropInfo?.is_fail_warning ? (
          <Tooltip title={`Невыполнение плана ${ropInfo?.fail_streak} мес. подряд`}>
            <ReportProblemIcon fontSize="small" style={{color: "#FF6262", verticalAlign: "middle", marginLeft: 4}}/>
          </Tooltip>
        ) : null}
      </span>
    </Box>
    <Box className={classes.kpi_info_total}>
      <p>Бонус:</p>
      <span>
        <NumberFormat
          value={ropInfo?.rop_bonus}
          thousandSeparator={" "}
          displayType="text"
        />
      </span>
    </Box>
  </Box>
}
